import dynamic from "next/dynamic";

import { useCallback, useEffect, useState } from "react";

import { NextPage } from "next";

import Container from "@mui/material/Container";

import Hero from "sections/landingPage/Hero";
import Ecosystem from "sections/landingPage/Ecosystem";
import Testimonials from "sections/landingPage/Testimonials";
import ProductSection from "sections/nfcTagsPage/ProductSection";
import Layout from "sections/landingPage/Layout";
import TabsSection from "sections/nfcTagsPage/TabsSection";
import AppSection from "sections/nfcTagsPage/AppSection";
import ContactSection from "sections/nfcTagsPage/ContactSection";
import PartnersCarousel from "sections/landingPage/PartnersCarousel";

const DiscoverySection = dynamic(
  import("sections/nfcTagsPage/DiscoverySection"),
  {
    ssr: false,
  },
);

const ProcessSection = dynamic(import("sections/nfcTagsPage/ProcessSection"), {
  ssr: false,
});

const HomePage: NextPage = () => {
  /*
    We have two sections which use gsap with ScrollTrigger. This plugin calculates everything in useEffect
    hook (onMounted). Sometimes the calculations are outdated, because something in previous sections had loaded.
    So we wait until all assets are loaded to make calculations.
  */
  const [loadingStep, setLoadingStep] = useState(0);

  const increaseLoadingStep = useCallback(() => {
    setLoadingStep((prevState) => prevState + 1);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (event.target.readyState === "complete") {
        increaseLoadingStep();
      }
    };

    if (loadingStep !== 0) {
      return () => {
        window.removeEventListener("readystatechange", handler);
      };
    }

    if (document.readyState === "complete") {
      increaseLoadingStep();
      return () => {
        window.removeEventListener("readystatechange", handler);
      };
    }

    document.addEventListener("readystatechange", handler);

    return () => {
      window.removeEventListener("readystatechange", handler);
    };
  }, [increaseLoadingStep, loadingStep]);

  return (
    <Layout>
      <Hero />
      {/* <TopDrops />
      <TopStores /> */}
      <Container>
        <PartnersCarousel />

        <Ecosystem />
        <ProductSection
          boxProps={{
            mb: { xs: 12, md: 22, lg: 26 },
          }}
        />

        <DiscoverySection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
          setSectionLoaded={increaseLoadingStep}
          isReadyToStart={loadingStep === 1}
        />
        <TabsSection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
        />
        <AppSection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
        />
        <ProcessSection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
          setSectionLoaded={increaseLoadingStep}
          isReadyToStart={loadingStep === 2}
        />
      </Container>
      <Container></Container>
      <Testimonials />
      <Container>
        {/* <Contact /> */}
        <ContactSection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
        />
      </Container>
    </Layout>
  );
};

export default HomePage;
